import { useCallback } from 'react'

import { Button } from 'antd'
import { Element } from 'html-react-parser'

type Props = {
  id: string
  node: Element
  shouldDisableButtons?: boolean
  handleAIChat?: (text: string) => void
}

const ParsedHtmlButton = ({ id, node, shouldDisableButtons, handleAIChat }: Props) => {
  const dataChatText = node.attribs['data-chat-text'] ?? ''
  const handleClick = useCallback(() => {
    if (shouldDisableButtons) {
      return
    }
    handleAIChat?.(dataChatText)
  }, [handleAIChat, dataChatText, shouldDisableButtons])
  const firstChild = node.children?.[0]
  const text = (firstChild?.type === 'text' ? firstChild.data : undefined) ?? 'Click'
  return (
    <Button
      id={id}
      type="default"
      onClick={handleClick}
      disabled={shouldDisableButtons}
      {...(shouldDisableButtons ? { className: 'pointer-events-none' } : {})}
    >
      {text}
    </Button>
  )
}

export default React.memo(ParsedHtmlButton)
